import bytteIkonFigma from "../../../../static/img/ikoner/bytte-ikon-figma.png";
import nyttIkonFigma from "../../../../static/img/ikoner/nytt-ikon-figma.png";
import bytteFargeFigma from "../../../../static/img/ikoner/bytte-farge-figma.png";
import * as React from 'react';
export default {
  bytteIkonFigma,
  nyttIkonFigma,
  bytteFargeFigma,
  React
};